module.exports = __webpack_public_path__ + "img/Hoja_Derecha.6cd0ee71.svg";